import React, { createContext, useMemo, useState } from 'react';
type OptinsContextType = {
  optins: any;
  setOptins: (optins: any) => void;
};
type Props = {
  children: ReactNode;
};
export const OptinsContext = createContext<OptinsContextType>({
  optins: {},
  setOptins: () => {},
});
export const OptinsProvider = ({ children }: Props) => {
  const [optins, setOptins] = useState({});
  const value = useMemo(
    () => ({
      optins,
      setOptins,
    }),
    [optins],
  );
  return <OptinsContext.Provider value={value}>{children}</OptinsContext.Provider>;
};
